import { LessonStatus } from 'src/@types/modules/attendance/attendance.enums';
import { LessonBase } from 'src/@types/modules/lessons/lessons.types';
import { EnumWithKey } from 'src/@types/modules/common.types';
import { Student__Legacy } from 'src/api/endpoints/students';
import { Lesson } from 'src/api/endpoints/lessons/lessons.types';

export type LessonType = EnumWithKey;

export type AttendanceHistory = {
    id: number;
    student: Student__Legacy;
    lesson: Lesson;
    status: AttendanceStatus;

    hasValidReason: boolean | null;
    reason: string | null;
};

export enum AttendanceStatuses {
    Present = 0,
    Absent = 1,
    Late = 2,
    NotMarked = 3,
}

export type AttendanceStatus = EnumWithKey<AttendanceStatuses>;

export type StudentAttendance = {
    // student payload
    studentId: number;
    fullname: string;
    // attendance payload
    id: number;
    mark: number;
    reward: number;
    comment: string | null;
    status: AttendanceStatus;
};

export type RawStudentAttendance = {
    // student payload
    studentId: number;
    fullname: string;
    // attendance payload
    id: number;
    mark: number;
    reward: number;
    comment: string | null;
    status: AttendanceStatuses;
};

export type UpdatingStudentAttendanceBase = {
    status: number;
};

export type UpdatingStudentAttendance = UpdatingStudentAttendanceBase & {
    mark: number;
    reward: number;
    comment: string | null;
};

export type AttendanceLesson = LessonBase & {
    status: LessonStatus;
};
